import { Descriptions, Divider } from "antd";
import { Typography } from "antd";
import { labelStyle } from "../RequestUtil";

const { Title } = Typography;

const reasonLabels = {
  overdue_rent: "차임 연체 (3기 이상)",
  expired_stay: "계약 만료 후 미퇴거",
  illegal_sublease: "무단 전대(전전세)",
  misuse: "용도 위반 사용",
  demolition: "건물 철거/재건축",
  etc: "기타",
  "월세미납": "월세미납",
  "계약만료": "계약만료",
  "계약위반": "계약위반",
  "불법점유": "불법점유",
  "기타사유": "기타사유",
};

const residenceLabels = {
  living: "현재 거주 중",
  left_stuff: "퇴거했으나 짐이 남아있음",
  unknown: "확인 불가",
};

const documentLabels = {
  contract: "임대차계약서",
  certification: "내용증명 사본",
  registry: "등기부등본",
  overdue_proof: "차임 연체 증빙",
};

const VacatehouseRequest = ({ serviceData, requestData }) => {
  const reactiveColumn = {
    xxl: 1,
    xl: 1,
    lg: 1,
    md: 1,
    sm: 1,
    xs: 1,
  };

  return (
    <>
      <Title level={4} style={{ color: "#001529", marginBottom: 0 }}>
        명도소송
      </Title>
      <Divider style={{ marginTop: 10 }} />
      <div
        style={{
          backgroundColor: "white",
          padding: 15,
          paddingTop: 5,
          marginBottom: 20,
          borderRadius: 5,
        }}
      >
        {serviceData.contract && (
          <Descriptions
            title="임대차 계약 정보"
            bordered
            column={reactiveColumn}
            size={"small"}
            style={{ marginTop: 20, marginBottom: 15 }}
          >
            <Descriptions.Item label="계약 일자" labelStyle={labelStyle}>
              {serviceData.contract.date || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="보증금" labelStyle={labelStyle}>
              {serviceData.contract.deposit?.amount
                ? `${serviceData.contract.deposit.amount.toLocaleString()}원`
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="월세 유무" labelStyle={labelStyle}>
              {serviceData.contract.monthlyRent?.exist === "y" ? "예" : "아니오"}
            </Descriptions.Item>
            {serviceData.contract.monthlyRent?.exist === "y" && (
              <>
                <Descriptions.Item label="월세 금액" labelStyle={labelStyle}>
                  {serviceData.contract.monthlyRent.amount
                    ? `${serviceData.contract.monthlyRent.amount.toLocaleString()}원`
                    : "-"}
                </Descriptions.Item>
                <Descriptions.Item label="월세 지급일" labelStyle={labelStyle}>
                  {serviceData.contract.monthlyRent.date
                    ? `매월 ${serviceData.contract.monthlyRent.date}일`
                    : "-"}
                </Descriptions.Item>
              </>
            )}
            <Descriptions.Item label="목적물 주소" labelStyle={labelStyle}>
              {serviceData.contract.address || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="계약 만료일" labelStyle={labelStyle}>
              {serviceData.contract.endDate || "-"}
            </Descriptions.Item>
          </Descriptions>
        )}

        <Descriptions
          title="명도소송 사유"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >
          <Descriptions.Item label="명도소송 이유" labelStyle={labelStyle}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {serviceData.vacatehouse.reason.map((option, index) => (
                <li key={index}>{reasonLabels[option] || option}</li>
              ))}
            </ul>
          </Descriptions.Item>
          {serviceData.vacatehouse.reasonEtc && (
            <Descriptions.Item label="기타 사유" labelStyle={labelStyle}>
              {serviceData.vacatehouse.reasonEtc}
            </Descriptions.Item>
          )}
          {serviceData.vacatehouse.overdueAmount && (
            <Descriptions.Item label="연체 차임 총액" labelStyle={labelStyle}>
              {serviceData.vacatehouse.overdueAmount.toLocaleString()}원
            </Descriptions.Item>
          )}
          <Descriptions.Item label="내용증명 발송 여부" labelStyle={labelStyle}>
            {serviceData.vacatehouse.certification === "y" ? "예" : "아니오"}
          </Descriptions.Item>
          {serviceData.vacatehouse.certificationDate && (
            <Descriptions.Item label="내용증명 발송일" labelStyle={labelStyle}>
              {serviceData.vacatehouse.certificationDate}
            </Descriptions.Item>
          )}
          {serviceData.vacatehouse.terminationNotice && (
            <Descriptions.Item label="계약 해지 통보" labelStyle={labelStyle}>
              {serviceData.vacatehouse.terminationNotice === "y" ? "예" : "아니오"}
            </Descriptions.Item>
          )}
        </Descriptions>

        {serviceData.tenant && (
          <Descriptions
            title="임차인 정보"
            bordered
            column={reactiveColumn}
            size={"small"}
            style={{ marginTop: 20, marginBottom: 15 }}
          >
            <Descriptions.Item label="임차인 이름" labelStyle={labelStyle}>
              {serviceData.tenant.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="연락처" labelStyle={labelStyle}>
              {serviceData.tenant.phone || "미입력"}
            </Descriptions.Item>
            <Descriptions.Item label="주민번호 앞자리" labelStyle={labelStyle}>
              {serviceData.tenant.ssnYn === "y" ? "알고 있음" : "모름"}
            </Descriptions.Item>
            <Descriptions.Item label="거주 상태" labelStyle={labelStyle}>
              {residenceLabels[serviceData.tenant.residenceStatus] || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="제3자 거주" labelStyle={labelStyle}>
              {serviceData.tenant.thirdPartyOccupant === "y" ? "예" : "아니오"}
            </Descriptions.Item>
          </Descriptions>
        )}

        <Descriptions
          title="추가 정보"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >
          {serviceData.documents && serviceData.documents.length > 0 && (
            <Descriptions.Item label="보유 서류" labelStyle={labelStyle}>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                {serviceData.documents.map((doc, idx) => (
                  <li key={idx}>{documentLabels[doc] || doc}</li>
                ))}
              </ul>
            </Descriptions.Item>
          )}
          {serviceData.injunctionRequest && (
            <Descriptions.Item label="가처분 신청 희망" labelStyle={labelStyle}>
              {serviceData.injunctionRequest === "y" ? "예" : "아니오"}
            </Descriptions.Item>
          )}
          {serviceData.overdueClaimRequest && (
            <Descriptions.Item label="밀린 차임 청구" labelStyle={labelStyle}>
              {serviceData.overdueClaimRequest === "y" ? "예" : "아니오"}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="상세 내용" labelStyle={labelStyle}>
            {serviceData.description
              ? serviceData.description.split("\n").map((line, idx) => {
                  return (
                    <span key={idx}>
                      {line}
                      <br />
                    </span>
                  );
                })
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="연락처" labelStyle={labelStyle}>
            {serviceData.contact}
          </Descriptions.Item>
          <Descriptions.Item label="프로모션" labelStyle={labelStyle}>
            {serviceData.promotionCode}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default VacatehouseRequest;
